import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Image, WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner as Type } from '../../../../types/uncinc_profile/nodes';

import './style.scss';

interface NodePartnerTeaserProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

interface LogoProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  logo?: string;
  title: string;
}

const Logo: React.FC<LogoProps> = ({ logo, title }) => (
  <>
    {logo && (
      <div className="NodePartnerTeaser__logo">
        <Image src={logo} alt={title} />
      </div>
    )}
    <div className="NodePartnerTeaser__content">
      <h4 className="NodePartnerTeaser__title">{title}</h4>
    </div>
  </>
);

const NodePartnerTeaser: React.FC<NodePartnerTeaserProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodePartnerTeaser');
  const partner = entity.toJS();
  const title = partner.title[0].value;
  const logo = partner.field_media_item[0]?.styles?.original;
  const link = partner.field_link[0];
  const linkUrl = link?.alias || link?.uri;
  const linkText = partner.field_link[0]?.title;
  const body = partner.body[0]?.processed;
  const address = partner.field_location[0]?.entity?.field_address[0];
  const postalAddress = partner.field_location[0]?.entity?.field_postal_address[0];
  const telephone = partner.field_telephone[0]?.value;
  const email = partner.field_email_address[0]?.value;

  return (
    <div className={classes}>
      {linkUrl ? (
        <CoreLink href={linkUrl}>
          <Logo
            logo={logo}
            title={title}
          />
        </CoreLink>
      ) : (
        <Logo
          logo={logo}
          title={title}
        />
      )}
      {body ? (
        <WysiwygField
          property="schema:text"
          html={body}
        />
      ) : null}

      {address && (
        <div className="NodePartnerTeaser__section">
          <p className="NodePartnerTeaser__section__title">Bezoekadres</p>
          <p className="NodePartnerTeaser__address__details"><span className="icon icon-pin icon-variant-2" /> {address.address_line1}, {address.postal_code} {address.locality}</p>
        </div>
      )}

      {postalAddress && (
        <div className="NodePartnerTeaser__section">
          <p className="NodePartnerTeaser__section__title">Postadres</p>
          <p className="NodePartnerTeaser__address__details"><span className="icon icon-pin icon-variant-2" /> {postalAddress.address_line1}, {postalAddress.postal_code} {postalAddress.locality}</p>
        </div>
      )}

      <div className="NodePartnerTeaser__section">
        <p className="NodePartnerTeaser__section__title">Contactgegevens</p>
        <div className="NodePartnerTeaser__contact__details">
          {telephone && (
            <p>
              <CoreLink href={`tel:${telephone}`}>
                <span className="icon icon-phone icon-variant-2" />{telephone}
              </CoreLink>
            </p>
          )}
          {email && (
            <p>
              <CoreLink href={`mailto:${email}`}>
                <span className="icon icon-mail icon-variant-2" />{email}
              </CoreLink>
            </p>
          )}
          {linkUrl && (
            <p>
              <CoreLink href={linkUrl}>
                <span className="icon icon-globe icon-variant-2" />{linkText && linkText.length > 0 ? linkText : linkUrl}
              </CoreLink>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NodePartnerTeaser;
